import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';

import { TranslateModule } from '@ngx-translate/core';
import {
  MatOption,
  MatSelect,
  MatSelectChange,
} from '@angular/material/select';
import { TravellersTransformerPipe } from '../trip-wizard/travellers-transformer.pipe';

enum BoxType {
  ADULTS,
  CHILDREN,
  ROOMS,
}

@Component({
    selector: 'app-travelers-setting',
    imports: [NgTemplateOutlet, TranslateModule, MatSelect, MatOption],
    templateUrl: './travelers-setting.component.html',
    styleUrl: './travelers-setting.component.scss'
})
export class TravelersSettingComponent {
  @Output() payload: EventEmitter<any> = new EventEmitter<any>();

  public childOptions = [
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17,
  ].map((age) => ({ label: `${age} yrs.`, value: age }));
  public adultsAmount: number;
  public childrenAmount: number;
  public roomsAmount: number;
  public ages: number[] = [];
  public boxType = BoxType;

  #travellersTransformerPipe = inject(TravellersTransformerPipe);

  @Input() set travelersConfig(data: any) {
    this.adultsAmount = this.#travellersTransformerPipe.getTotalByProperty(
      data,
      'adults',
    );
    this.childrenAmount = this.#travellersTransformerPipe.getTotalByProperty(
      data,
      'children',
    );
    this.roomsAmount = this.#travellersTransformerPipe.getTotalByProperty(
      data,
      'rooms',
    );
    this.ages = data.ages.slice();
    this.emitPayloadChanges();
  }

  public changeAmount(type: BoxType, value: number): void {
    switch (type) {
      case BoxType.ADULTS:
        this.adultsAmount += value;
        if (this.adultsAmount < 2) this.adultsAmount = 1;
        if (this.adultsAmount >= 16) this.adultsAmount = 16;
        this.changeAmount(BoxType.ROOMS, 0);
        this.changeAmount(BoxType.CHILDREN, 0);
        break;
      case BoxType.CHILDREN:
        this.childrenAmount += value;
        if (this.childrenAmount < 0) this.childrenAmount = 0;
        if (this.childrenAmount > this.roomsAmount * 3) {
          this.childrenAmount = this.roomsAmount * 3;
        }
        if (this.ages.length < this.childrenAmount) {
          this.ages = [
            ...this.ages,
            ...Array(this.childrenAmount - this.ages.length).fill(4),
          ];
        } else {
          this.ages = this.ages.slice(0, this.childrenAmount);
        }
        break;
      case BoxType.ROOMS:
        this.roomsAmount += value;
        if (this.roomsAmount < 1) this.roomsAmount = 1;
        if (this.roomsAmount > 6) this.roomsAmount = 6;
        this.changeAmount(BoxType.CHILDREN, 0);
        break;
    }
    this.emitPayloadChanges();
  }

  public selectionChange(event: MatSelectChange, index: number): void {
    this.ages.splice(index, 1, event.value);
    this.emitPayloadChanges();
  }

  private emitPayloadChanges() {
    this.payload.emit({
      adults: this.adultsAmount,
      children: this.childrenAmount,
      ages: this.ages,
      rooms: this.roomsAmount,
    });
  }
}
